import { textColumnCls } from '@pm2/react-utils';
import { header, heading } from '../../shared.header.style.js';
import { contentWrapperCls } from './_page.style.js';
import { SpeechSynthesis } from './speech-synthesis.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SpeechSynthesisPane() {
  return /*#__PURE__*/jsxs("div", {
    className: textColumnCls,
    children: [/*#__PURE__*/jsx("header", {
      className: header,
      children: /*#__PURE__*/jsx("h1", {
        className: heading,
        children: "Indstil opl\xE6sning"
      })
    }), /*#__PURE__*/jsx("div", {
      className: contentWrapperCls,
      children: /*#__PURE__*/jsx(SpeechSynthesis, {})
    })]
  });
}

export { SpeechSynthesisPane };
//# sourceMappingURL=_page.js.map
